module.exports = __webpack_public_path__ + "img/product_85.5fe208f.webp";